<template>
  <div>
    <v-row>
      <v-col
        class="d-flex align-center"
        cols="12"
        sm="3">
        <v-btn-toggle v-model="direction" mandatory @change="setDirection">
          <v-btn :value="'asc'">
            <v-icon>mdi-sort-ascending</v-icon>
          </v-btn>
          <v-btn :value="'desc'">
            <v-icon>mdi-sort-descending</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col
        class="d-flex align-center"
        cols="12"
        sm="8">
        <v-select
          class="px-5"
          id="sms-sort-by"
          v-model="sortByFilter"
          :items="properties"
          :label="$t('chat.smsContextMenu.filterSortBy')"
          style="max-width: 210px;z-index: 999"
          item-value="value"
          item-text="display"
          @change="setProperty"
          chips
        >
         <template v-slot:selection="{ item }">
            <v-chip>
              <span>{{ $t(`chat.smsContextMenu.properties.${item.value}`) }}</span>
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <span>{{ $t(`chat.smsContextMenu.properties.${item.value}`) }}</span>
          </template>
        </v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ChatLocalStorage from '@/api/chat'

export default {
  name: 'chat-sort',
  data () {
    return {
      direction: 'asc',
      sortByFilter: 'recent_activity',
      properties: [
        {
          value: 'recent_activity'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      smsConversations: 'chat/smsConversations'
    })
  },
  created () {
    this.applySort()
  },
  methods: {
    ...mapActions({
      setProperty: 'chat/SmsSortByFilter/setProperty',
      setDirection: 'chat/SmsSortByFilter/setDirection'
    }),

    applySort () {
      const smsSortProperty = ChatLocalStorage.smsSortProperty()
      if (smsSortProperty) {
        this.sortByFilter = smsSortProperty
      }
      const direction = ChatLocalStorage.smsSortDirection()
      if (direction) {
        this.direction = direction
      }
    }
  }
}
</script>

<style scoped>
  .v-text-field >>> label {
    font-size: 0.8em;
  }
</style>
